import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Button, Row, Tooltip, Form,Pagination, Col} from 'antd';
import {Field, reduxForm} from "redux-form";

import TextField from '../formFields/TextField';
import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        sorter: (a, b) => a.key - b.key,
        width:'7%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width: "10%"
    },
    {
        title: 'عنوان',
        dataIndex: 'title',
        width: "20%"
    },
    {
        title: 'نوع محصول',
        dataIndex: 'product_type',
        width: "10%"
    },
    {
        title: 'توضیحات',
        dataIndex: 'description',
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        width: "10%"
    },
];

const expandedRowRender = record => <div>{record.extraInfo}</div>;

class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.page_number : 1),
            expandedRowRender,
            filter:[],
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentWillMount() {
        this.props.getList();
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        clearInterval(this.interval);
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];

        if(list) {
            for (let i = 0; i < list.lists.length; i++) {

                dataSource.push({
                    key: i+1,
                    system_code: list.lists[i].system_code,
                    title: list.lists[i].title,
                    product_type: list.lists[i].product_type === 'PRODUCT_CATEGORY_CUSTOMER_TYPE' ? 'مشتری' : 'تکنسین',
                    description: list.lists[i].description,
                    action: <Tooltip placement="top" title="ویرایش">
                                <a href={"#/product-category/edit/"+list.lists[i]._id} className="listBtn"><Icon type="edit" /></a>
                            </Tooltip>
                });
            }
        }
        return dataSource;
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    async __onChangeCounter(current, pageSize) {
        clearInterval(this.interval);
        this.setState({size:pageSize});
        this.setState({pageSize:pageSize})
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList();
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const { searchBoxHidden,pageSize } = this.state;
        const { list } = this.props;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={18}>
                        <Divider orientation="left">لیست دسته بندی محصولات</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={6} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/product-category/add">
                            ایجاد دسته بدندی
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="categoryList" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="title"
                                    component={TextField}
                                    type="text"
                                    placeholder="عنوان"
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="product_type"
                                    component={SelectField}
                                    placeholder="نوع محصول"
                                    list={[
                                        {label: 'مشتری', value: 'PRODUCT_CATEGORY_CUSTOMER_TYPE', key: 1},
                                        {label: 'تکنسین', value: 'PRODUCT_CATEGORY_TECHNICIAN_TYPE', key: 2}
                                    ]}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                 <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } {...this.state} pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : this.state.size)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions={['10', '20','30','40','50','60','70','80','90','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default List = reduxForm({
    form: 'categoryList'
})(List)
